export default __webpack_public_path__ + "static/media/meal1.8478cb3a.jpg";